import { useEffect, useState } from 'react';

import type { ResolvedTheme } from './models';

const DARK_QUERY = '(prefers-color-scheme: dark)';

const readSystemTheme = (): ResolvedTheme => (typeof window !== 'undefined' && window.matchMedia(DARK_QUERY).matches ? 'dark' : 'light');

// Tracks the OS colour-scheme and re-renders when it flips, so a plan
// set to `system` repaints live when the user toggles their OS theme.
export const useSystemTheme = (): ResolvedTheme => {
    const [systemTheme, setSystemTheme] = useState<ResolvedTheme>(readSystemTheme);

    useEffect(() => {
        const media = window.matchMedia(DARK_QUERY);
        const onChange = (e: MediaQueryListEvent) => setSystemTheme(e.matches ? 'dark' : 'light');
        media.addEventListener('change', onChange);
        return () => media.removeEventListener('change', onChange);
    }, []);

    return systemTheme;
};
